<template>
    <div class="row wrap">
        <div class="gallery col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h1 class="gallery-title">{{ $t('exampleProjects.exampleProject') }}</h1>
        </div>

        <div class="mb-3">
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('all') }"
                @click="setFilter(['all'])">{{ $t('exampleProjects.all') }}</button>

            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('pinned') }"
                @click="setFilter(['pinned'])">{{ $t('exampleProjects.pinned') }}</button>
        </div>

        <div class="mb-3">
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('work') }"
                @click="setFilter(['work'])">{{ $t('exampleProjects.work') }}</button>
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('school') }"
                @click="setFilter(['school'])">{{ $t('exampleProjects.school') }}</button>
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('private') }"
                @click="setFilter(['private'])">{{ $t('exampleProjects.private') }}</button>
        </div>

        <div class="mb-3">
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('CSharp') }"
                @click="setFilter(['CSharp'])">C#</button>
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('Java') }"
                @click="setFilter(['Java'])">Java</button>
            <button type="button" class="btn btn-primary me-2"
                :class="{ active: currentFilter.includes('Dart') || currentFilter.includes('Flutter') || currentFilter.includes('Kotlin') }"
                @click="setFilter(['Dart', 'Flutter', 'Kotlin'])">Apps</button>
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('JavaScript') }"
                @click="setFilter(['JavaScript', 'Vue', 'Angular', 'Phoenix', 'Thymeleaf', 'HTML', 'Symfony'])">Web</button>
            <button type="button" class="btn btn-primary me-2" :class="{ active: currentFilter.includes('WordPress') }"
                @click="setFilter(['WordPress'])">WordPress</button>
        </div>
        <ProjectPreview v-for="project in projects" :key="project.id" :id="project.id" :title="project.title"
            :desc="project.desc" :solution="project.solution" :type="project.type" :tech="project.tech"
            :createdAt="project.createdAt" :git="project.git" :link="project.link" :img="project.img"
            :pinned="project.pinned" />
    </div>
</template>


<script>
import $ from 'jquery';
import ProjectPreview from '@/components/ExampleProjects/ProjectPreview.vue'

export default {
    name: 'ExampleProjects',
    methods: {
        filterProjects(filterName) {
            $('.filter').not('.' + filterName).hide('1000');

            for (var i = 0; i < filterName.length; i++) {
                var filter = filterName[i];

                if (filter == "all") {
                    $('.filter').show('1000');
                }
                else {
                    $('.filter').filter('.' + filter).show('1000');
                }
            }
        },
        setFilter(filter) {
            this.currentFilter = filter;
            this.filterProjects(filter);
        }

    },
    mounted() {
        // Set default filter on page load
        this.filterProjects(this.currentFilter);
    },
    data() {
        return {
            projects: [
                {
                    id: "1",
                    title: 'projects.envenanceEnvialon.title',
                    desc: 'projects.envenanceEnvialon.desc',
                    solution: 'projects.envenanceEnvialon.solution',
                    type: "work",
                    tech: ["Symfony", "PHP", "MariaDB", "REST", "Nginx", "GitLab"],
                    createdAt: "2024",
                    link: "https://bavarianbits.de/envenance-envialon/",
                    img: "envenanceEnvialon.png",
                    pinned: true
                },
                {
                    id: "2",
                    title: 'projects.artnerApp.title',
                    desc: 'projects.artnerApp.desc',
                    solution: 'projects.artnerApp.solution',
                    type: "work",
                    tech: ["Flutter", "Dart", "REST", "Android", "iOS", "Windows"],
                    createdAt: "2024",
                    link: "https://bavarianbits.de/artner-business-center/",
                    img: "artnerApp.png",
                    pinned: true
                },
                {
                    id: "3",
                    title: 'projects.bachelorThesis.title',
                    desc: 'projects.bachelorThesis.desc',
                    solution: 'projects.bachelorThesis.solution',
                    type: "school",
                    tech: ["Flutter", "Dart", "FastDTW", "Machine Learning", "Smartwatch"],
                    createdAt: "2024",
                    link: "https://www.lfdr.de/Theses/2024/BA-Schottenhammer.html",
                    img: "bachelorarbeit.png",
                    pinned: true
                },
                {
                    id: "4",
                    title: 'projects.mrmrshomes.title',
                    desc: "projects.mrmrshomes.desc",
                    solution: "projects.mrmrshomes.solution",
                    type: "work",
                    tech: ["Phoenix", "Elixir", "C#", "GRPC"],
                    createdAt: "2023",
                    link: "https://www.mrmrshomes.de/",
                    img: "mrmrshomes.png",
                    pinned: true
                },
                {
                    id: "5",
                    title: 'projects.achivementRideWithMe.title',
                    desc: "projects.achivementRideWithMe.desc",
                    solution: "projects.achivementRideWithMe.solution",
                    type: "private",
                    tech: ["Dart", "Flutter", "Firebase", "Firestore", "TypeScript"],
                    createdAt: "2021",
                    link: "https://ridewithme.app/",
                    img: "AchivementsRideWithMe.jpeg",
                    pinned: true
                },
                {
                    id: "6",
                    title: 'projects.deepDiveApp.title',
                    desc: 'projects.deepDiveApp.desc',
                    solution: 'projects.deepDiveApp.solution',
                    type: "work",
                    tech: ["Flutter", "Dart", "Firebase", "Firestore", "TypeScript"],
                    createdAt: "2024",
                    link: "https://bavarianbits.de/deep-dive-app/",
                    img: "deepDiveApp.png",
                    pinned: true
                },
                {
                    id: "7",
                    title: 'projects.websiteMSHausmeisterservice.title',
                    desc: 'projects.websiteMSHausmeisterservice.desc',
                    solution: 'projects.websiteMSHausmeisterservice.solution',
                    type: "work",
                    tech: ["WordPress", "Responsive Design", "SEO"],
                    createdAt: "2025",
                    link: "https://mshausmeisterservice.de/",
                    img: "websiteMSHausmeisterservice.png"
                },
                {
                    id: "8",
                    title: 'projects.portfolioWebsite.title',
                    desc: "projects.portfolioWebsite.desc",
                    solution: "projects.portfolioWebsite.solution",
                    type: "private",
                    tech: ["Vue", "Bootstrap", "SASS"],
                    createdAt: "2022",
                    git: "https://github.com/markus-schott/PersonalWebsite",
                    img: "portfolioWebsite.png"
                },
                {
                    id: "9",
                    title: 'projects.hammKliniken.title',
                    desc: "projects.hammKliniken.desc",
                    solution: "projects.hammKliniken.solution",
                    type: "work",
                    tech: ["Kotlin", "Espresso", "Gherkin"],
                    createdAt: "2023",
                    link: "https://www.hamm-kliniken.de/onkologische-rehabilitation/nach-der-reha/hamm-kliniken-app",
                    img: "hammKliniken.png"
                },
                {
                    id: "10",
                    title: 'projects.recipes.title',
                    desc: "projects.recipes.desc",
                    solution: "projects.recipes.solution",
                    type: "private",
                    tech: ["Angular", "TypeScript", "NgRx", "Firebase", "REST"],
                    createdAt: "2023",
                    img: "angularRecipesManager.jpg"
                },
                {
                    id: "11",
                    title: 'projects.ihk.title',
                    desc: "projects.ihk.desc",
                    solution: "projects.ihk.solution",
                    type: "school",
                    tech: [".NET", "C#", "WPF", "Java"],
                    createdAt: "2018",
                    link: "https://schottenhammer.com/documents/Projektdokumentation.pdf",
                    img: "IHKAbschlussarbeit.png"
                },
                {
                    id: "12",
                    title: 'projects.winewizard.title',
                    desc: "projects.winewizard.desc",
                    solution: "projects.winewizard.solution",
                    type: "school",
                    tech: ["Spring Framework", "Java", "Java EE", "JPA", "Thymeleaf", "H2 database", "API"],
                    createdAt: "2023",
                    img: "wineWizard.jpg"
                },
                {
                    id: "13",
                    title: 'projects.websiteKoller.title',
                    desc: "projects.websiteKoller.desc",
                    solution: "projects.websiteKoller.solution",
                    type: "private",
                    tech: ["HTML", "CSS", "JavaScript"],
                    createdAt: "2017",
                    link: "https://www.auto-koller.com",
                    img: "Koller.png"
                },
                {
                    id: "14",
                    title: 'projects.listicleRegensburg.title',
                    desc: "projects.listicleRegensburg.desc",
                    solution: "projects.listicleRegensburg.solution",
                    type: "school",
                    tech: ["HTML", "CSS"],
                    createdAt: "2021",
                    git: "https://github.com/markus-schott/WebpageRegensburg",
                    link: "https://schottenhammer.com/projects/listicle/",
                    img: "ListicleRegensburg.png"
                },
                {
                    id: "15",
                    title: 'projects.finance.title',
                    desc: "projects.finance.desc",
                    solution: "projects.finance.solution",
                    type: "school",
                    tech: ["PUG", "JavaScript", "PostgreSQL", "Bootstrap"],
                    createdAt: "2021",
                    git: "https://github.com/markus-schott/FinanceProject",
                    img: "Finance.png"
                },
                {
                    id: "16",
                    title: 'projects.websiteImmobilien.title',
                    desc: 'projects.websiteImmobilien.desc',
                    solution: 'projects.websiteImmobilien.solution',
                    type: "work",
                    tech: ["WordPress", "SEO", "Responsive Design"],
                    createdAt: "2024",
                    link: "https://bavarianbits.de/website-immobilienmakler/",
                    img: "websiteImmobilien.png"
                },
                {
                    id: "17",
                    title: 'projects.websiteBnB.title',
                    desc: 'projects.websiteBnB.desc',
                    solution: 'projects.websiteBnB.solution',
                    type: "work",
                    tech: ["WordPress", "SEO", "Responsive Design"],
                    createdAt: "2024",
                    link: "https://bavarianbits.de/neue-website-bundb-wohnbauprojekte-bautraeger/",
                    img: "websiteBnB.png"
                },
                {
                    id: "18",
                    title: 'projects.websiteSandreinigung.title',
                    desc: 'projects.websiteSandreinigung.desc',
                    solution: 'projects.websiteSandreinigung.solution',
                    type: "work",
                    tech: ["WordPress", "SEO", "Responsive Design"],
                    createdAt: "2025",
                    link: "https://srs-sandreinigung.com/",
                    img: "sandreinigungSeyfarth.png"
                },
                {
                    id: "19",
                    title: "projects.ttpFramework.title",
                    desc: "projects.ttpFramework.desc",
                    solution: "projects.ttpFramework.solution",
                    type: "work",
                    tech: ["C#", "Fluent NHibernate", "NUnit", "SQLite", "TeamCity", "Microservices"],
                    createdAt: "2018",
                    img: "ttp.png"
                },
                {
                    id: "20",
                    title: "projects.audiReportExplorer.title",
                    desc: "projects.audiReportExplorer.desc",
                    solution: "projects.audiReportExplorer.solution",
                    type: "work",
                    tech: ["C#", "PostgreSQL", "Stored Procedures", "XML", "GUI", "Jira", "GitLab"],
                    createdAt: "2018",
                    img: "reportExplorer.png"
                }
            ],
            currentFilter: 'pinned'
        }
    },
    components: {
        ProjectPreview
    }
}
</script>

<style lang="sass" scoped>
    .wrap
        width: 100%
    .btn
        color: white
        
    .gallery_product
        max-width: 100%
    .btn.active
        background-color: #002147 !important   // auffälliges Grün
        border: 2px solid #ffffff !important
        color: white !important
        box-shadow: 0 0 10px rgba(0,0,0,0.3)   // optional: leichter Schatten

</style>